import React, { Component } from "react";
import KenoGrid from "./KenoGrids";
import ControlPanel from "./ControlPanel";
import "./styles.css";
import KenoPayoutBar from "./KenoPayoutBar";
import KenoPayoutBoxes from "./KenoPayoutBoxes";
// import Celebration from "./popup/Celebration";
import diamond from '../../../../../assets/Kenostakewav/diamond.wav'
import ding from '../../../../../assets/Kenostakewav/ding.wav'
import autoselect from '../../../../../assets/Kenostakewav/autoselection.wav'
import selectcell from '../../../../../assets/Kenostakewav/selectcell.mp3'
import bet from '../../../../../assets/sounds/bet.mp3'
import clear from '../../../../../assets/sounds/clear.mp3'
import win from '../../../../../assets/sounds/win.mp3'
import clearbet from '../../../../../assets/Kenostakewav/clearbet.mp3'
import { Howl, Howler } from "howler";
// import Teenpathi from "../TeenPathi/Teenpathi";
import AlertManager from "./popup/AlertManager";
const diamondsound = new Howl({
    src: [diamond]  // Make sure the path is correct
});
const betsound = new Howl({
    src: [bet]  // Make sure the path is correct
});
const dingsound = new Howl({
    src: [ding]  // Make sure the path is correct
});
const clearsound = new Howl({
    src: [clear]  // Make sure the path is correct
});
const autoselectionsound = new Howl({
    src: [autoselect]  // Make sure the path is correct
});
const selectcellsound = new Howl({
    src: [selectcell]  // Make sure the path is correct
});
const winsound = new Howl({
    src: [win]  // Make sure the path is correct
});
const clearbetsound = new Howl({
    src: [clearbet]  // Make sure the path is correct
});
const chipData = [
    { color: "red", chip: 1 },
    { color: "black", chip: 5 },
    { color: "green", chip: 10 },
    { color: "blue", chip: 20 },
    { color: "purple", chip: 50 },
    { color: "yellow", chip: 100 },
    { color: "teal", chip: 500 },
    { color: "brown", chip: 1000 },
    { color: "black", chip: 5000 }
];

export class KenoMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isWindows: navigator.userAgentData?.platform === "Windows",
            isPotrait: navigator.userAgentData?.platform !== "Windows" && window.innerHeight > window.innerWidth,
            hoveredPayoutIndex: null,
            selectedNumbers: [],
            drawnNumbers: [],
            winpop: false,
            winAmount: 0,
            highlightcount: null,
            Gridcover: false,
            BetAmount: 1,
            alertMessage: ""

        };
        this.handleResize = this.handleResize.bind(this);
        this.celebrationRef = React.createRef();
        this.popupref = React.createRef()
        this.alertRef = React.createRef();
        this.interval = null;  // Store the interval globally in the component
        this.count = 0;

        // this.PAYOUT_TABLE = {
        //     1: [0, 3],
        //     2: [0, 1, 9],
        //     3: [0, 0.5, 2, 16],
        //     4: [0, 0.5, 1, 5, 50],
        //     5: [0, 0.5, 1, 3, 15, 100],
        //     6: [0, 0.5, 1, 2, 5, 30, 200],
        //     7: [0, 0.5, 1, 2, 3, 10, 50, 500],
        //     8: [0, 0.5, 1, 1.5, 2, 5, 20, 100, 1000],
        //     9: [0, 0.5, 0.8, 1.2, 2, 4, 10, 50, 200, 2000],
        //     10: [0, 0.5, 0.8, 1.2, 2, 4, 8, 15, 50, 200, 3000],
        // };
        this.PAYOUT_TABLE = props.keno_stake_payouts?.reduce((acc, element) => {
            acc[element.numMatches] = element.ratio;
            return acc;
        }, {}) || {};
    }



    componentDidMount() {
        window.addEventListener("resize", this.handleResize)
        window.addEventListener("orientationChange", this.handleResize)
        this.props.assestsLoaderFunction();


    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize)
        window.removeEventListener("orientationChange", this.handleResize)
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
    updatePlayerInfo() {

    }
    handleResize(event) {
        // console.log("Resize", event)
        // console.log("Resize", navigator.userAgentData, window)
        if (navigator.userAgentData?.platform == "Windows") {
            this.setState({ isWindows: true, isPotrait: false })
        } else if (window.innerHeight > window.innerWidth) {
            this.setState({ isWindows: false, isPotrait: true })
        } else {
            this.setState({ isWindows: false, isPotrait: false })
        }

    }
    BetAmounthandle = (data) => {


        const bet = Number(data);
        const balance = Number(this.props.balance);
        const remaining = balance - bet
        if (balance >= bet) {

            this.setState({ BetAmount: data });
        }
        if (data === '' || data === String(0)) {
            this.setState({ BetAmount: 1 });
        }
        console.log(this.state.BetAmount)
        if (clearbetsound && data === 0) {
            clearbetsound.play();
        }
        // this.clearBet()
        // if(this.props.balance>data.target.value){

        //     this.setState({ BetAmount: data.target.value });
        // }
        // if(data.target.value===''||data.target.value===String(0)){
        //    this.setState({ BetAmount: 1 }); 
        // }
    };
    HalfAmounthandler = () => {

        this.setState({ BetAmount: this.state.BetAmount * 0.5 });

    }
    DoubleAmounthandler = () => {
        this.setState({ BetAmount: this.state.BetAmount * 2 });
    }
    toggleNumber = (num) => {
        this.setState({ drawnNumbers: [], highlightcount: null });
        this.setState((prevState) => {
            const selected = prevState.selectedNumbers.includes(num)
                ? prevState.selectedNumbers.filter((n) => n !== num)
                : prevState.selectedNumbers.length < 10
                    ? [...prevState.selectedNumbers, num]
                    : prevState.selectedNumbers;
            return { selectedNumbers: selected };
        });
        if (selectcellsound) {
            Howler.stop();
            selectcellsound.play();
        }
    };

    drawNumbers = () => {


        const bet = Number(this.state.BetAmount) * 2;
        const balance = Number(this.props.balance);
        const remaining = balance - bet
        if (remaining < 0) {
            this.BetAmounthandle(1)
            this.setState({ BetAmount: 1 });
        }



        this.setState({ Gridcover: true })

        // console.log(this.state.selectedNumbers)
        const result = Array.from({ length: 40 }, (_, i) => this.state.selectedNumbers.includes(i + 1) ? '1' : '0');
        const outputString = result.join('|');
        // const putString = "0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|0|1|0|0|0|0|0|0|0|0|0|1|1|0|0|0|0|0|1|0|0";
        //                   "0|1|1|0|1|1|0|0|1|0|0|0|0|0|0|0|1|0|0|1|0|0|0|0|0|0|0|0|0|0|0|0|1|1|0|1|0|0|0|0"
        // console.log(putString.length)
        // console.log(outputString.length)
        if (betsound) {
            Howler.stop()
            betsound.play();
        }



        const body = {
            sessionId: sessionStorage.getItem("sessionId"),
            CN: "KENO_STAKE_BET",
            object: {
                betString: outputString,
                playerId: Number(this.props.playerId),
                gameId: this.props.gameId,
                betAmount: Number(this.state.BetAmount),
                handId: Number(this.props.gamestate.handId)
            },
        };
        this.props.network.sendof(body);
        this.showAlert(`Bet Accepted !! your bet amount is ${this.state.BetAmount}`)

        // const body1 = {
        //     sessionId: sessionStorage.getItem("sessionId"),
        //     CN: "GET_PLAYER_INFO",
        //     object: {
        //         playerId: Number(this.props.playerId),
        //         gameId: this.props.gameId,
        //     },
        // };
        // this.props.network.sendof(body1);
    };

    updateGameState = () => {
        if (this.props?.gamestate?.handId !== this.props?.gamestate?.oldHandId) {
            this.setState({ Gridcover: false })
        }
    }


    DrawResult(data) {
        // alert("hh")
        // console.log(data)


        const all = Array.from({ length: 40 }, (_, i) => i + 1);
        // const drawn = all.sort(() => 0.5 - Math.random()).slice(0, 10);
        const drawn = data?.resultNo;
        // this.setState({ drawnNumbers: drawn });
        Howler.stop()
        this.setState({ winAmount: data.winAmount, Gridcover: true, winpop: false })
        let count = 0;
        this.setState({ drawnNumbers: [] });
        const interval = setInterval(() => {
            this.setState((prevState) => {
                const updated = [...prevState.drawnNumbers, drawn[count]];
                return { drawnNumbers: updated };
            });
            // console.log(this.state.drawnNumbers, this.state.selectedNumbers, this.state.selectedNumbers.filter(num => this.state.drawnNumbers.includes(num)))
            const matches = this.state.selectedNumbers.filter(num => this.state.drawnNumbers.includes(num))
            // console.log(this.state.selectedNumbers.includes(drawn[count]))


            // if (this.state.selectedNumbers.includes(drawn[count])) {
            //     // Howler.stop()
            //     diamondsound.play();
            // }
            // else {

            //     dingsound.play();
            // }
            if (dingsound) {
                dingsound.play();
            }

            this.setState({ highlightcount: matches.length })
            count++;

            if (count >= 10) {
                clearInterval(interval);
                //  this.celebrationRef.current?.triggerCelebration();
                // this.setState({ Gridcover: false })
                if (Number(data.winAmount) != 0) {

                    if (winsound) {
                        Howler.stop()
                        winsound.play()
                    }
                    this.setState({ winpop: true }, () => {






                        setTimeout(() => {
                            this.setState({ winpop: false });

                            const body = {
                                sessionId: sessionStorage.getItem("sessionId"),
                                CN: "GET_PLAYER_INFO",
                                object: {
                                    playerId: Number(this.props.playerId),
                                    gameId: this.props.gameId,
                                },
                            };
                            // this.props.network.sendof(body);
                            const body1 = {
                                sessionId: sessionStorage.getItem("sessionId"),
                                CN: "GET_GAME_STATE",
                                object: {
                                    playerId: Number(this.props.playerId),
                                    gameId: this.props.gameId,
                                },
                            };
                            this.props.network.sendof(body1);






                        }, 3000);
                    });
                }
                else {
                    const body = {
                        sessionId: sessionStorage.getItem("sessionId"),
                        CN: "GET_PLAYER_INFO",
                        object: {
                            playerId: Number(this.props.playerId),
                            gameId: this.props.gameId,
                        },
                    };
                    // this.props.network.sendof(body);


                    const body1 = {
                        sessionId: sessionStorage.getItem("sessionId"),
                        CN: "GET_GAME_STATE",
                        object: {
                            playerId: Number(this.props.playerId),
                            gameId: this.props.gameId,
                        },
                    };
                    this.props.network.sendof(body1);
                }

            }
        }, 200); // 200ms delay between each pick
        const body1 = {
            sessionId: sessionStorage.getItem("sessionId"),
            CN: "GET_GAME_STATE",
            object: {
                playerId: Number(this.props.playerId),
                gameId: this.props.gameId,
            },
        };
        // this.props.network.sendof(body1);
    }


    clearBet = () => {
        if (clearsound) {
            Howler.stop()
            clearsound.play()
        }
        this.setState({
            selectedNumbers: [],
            drawnNumbers: [],
            Gridcover: false,
            highlightcount: null // Optional: reset drawn numbers too
        });
        this.showAlert(``)
        this.BetAmounthandle(1)
    };
    autoPick = () => {
        const numbers = Array.from({ length: 40 }, (_, i) => i + 1);
        const shuffled = numbers.sort(() => 0.5 - Math.random());
        const picked = shuffled.slice(0, 10);
        if (this.interval) return;

        Howler.stop();
        this.count = 0;
        this.setState({ selectedNumbers: [], drawnNumbers: [], highlightcount: null, Gridcover: true });

        this.interval = setInterval(() => {
            this.setState((prevState) => {
                const updated = [...prevState.selectedNumbers, picked[this.count]];
                return { selectedNumbers: updated };
            });

            this.count++;
            if (autoselectionsound) {

                autoselectionsound.play();
            }

            if (this.count >= 10) {
                clearInterval(this.interval);
                this.setState({ Gridcover: false })
                this.interval = null;
            }
        }, 200); // 200ms delay between each pick
    };
    handleHoverPayout = (index) => {
        // console.log(index)
        this.setState({ hoveredPayoutIndex: index });
    };
    showAlert = (message) => {
        // this.setState({ alertMessage: message });
        if (this.alertRef.current) {
            this.alertRef.current.showAlertIfNeeded(message);
        }
    };
    updateMessage(data) {
        this.showAlert(data)
    }
    render() {


        const allowedChips = this.props.Keno_stake_chipValues.split(',').map(Number);

        const filteredChips = chipData.filter(chip => allowedChips.includes(chip.chip));

        return (
            <>
                {/* {this.state.winpop ? <Celebration ref={this.celebrationRef} winAmount={this.state.winAmount} /> : ""} */}

                <div className="keno-container"

                // style={{ position: this.state.isPotrait ? 'relative' : 'fixed', }}
                >

                    <AlertManager message={this.state.alertMessage} duration={2000} ref={this.alertRef} isPotrait={this.state.isPotrait} />
                    <div className="KenoGrid" >
                        <div className=" topContainer">
                            <div className="col-2 leftfloat">
                                <span>PLAYER : <label>{this.props.user}</label></span>
                                <span>P ID :<label>{this.props.playerId}</label></span>
                                <span>H ID : <label>{this.props.gamestate.handId}</label></span>
                            </div>
                            <div className="col-6 ratiopayout">
                                {this.props?.KenoGameState_stake_history?.map((val, index) => {
                                    return (
                                        <span key={index}>{val}</span>
                                    )
                                })}
                            </div>
                            {/* <div className="col-2"><span>H ID :</span><label>{this.props.playerId}</label></div> */}
                            {/* <div className="col-3 bottom_container"><span>PLAYER :</span><label>{this.props.user}</label></div> */}
                            {/* <div className="col-3 rightfloat"><span>Balance :<label>{(Number(this.props.balance) - Number(this.state.BetAmount)).toFixed(2)}</label></span></div> */}
                            <div className="rightfloat"><span>Balance : <label>{(Number(this.props.balance)).toFixed(2)}</label></span></div>
                        </div>
                        {this.state.winpop && <div className="windisplay" ref={this.popupref}>
                            <div className={`${this.state.isPotrait ? 'col-4' : 'col-2'} winContainer`}>
                                <div><span style={{ fontSize: "xxx-large" }}>{this?.PAYOUT_TABLE[this.state?.selectedNumbers?.length][this.state?.highlightcount]}</span><label>X</label></div>
                                {/* <div><span style={{ fontSize: "xxx-large" }}>{2.0}</span><label>X</label></div> */}
                                <div></div>
                                <div><span>{this.state?.winAmount}</span></div>

                            </div>
                        </div>}
                        <KenoGrid
                            selected={this.state.selectedNumbers}
                            drawn={this.state.drawnNumbers}
                            toggleNumber={this.toggleNumber}
                            Gridcover={this.state.Gridcover}
                            CELL_SIZE={this.state.isPotrait ? 210 : 180}
                            GRID_COLS={this.state.isPotrait ? 5 : 8}
                            GRID_ROWS={this.state.isPotrait ? 8 : 5}


                        />

                        <div className="" style={{ transform: "s" }}>
                            {/* {this.state.hoveredPayoutIndex !== null && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        // left: 50 + this.state.hoveredPayoutIndex * 130, // adjust as per box width
                                        // top: 300, // adjust vertical position
                                        marginTop: "-65px",
                                        marginLeft: `${(this.state.hoveredPayoutIndex * 130) - 275}px`,
                                        zIndex: 10
                                    }}
                                >
                                    <KenoPayoutBar selectedCount={this.state.selectedNumbers.length} />
                                </div>
                            )} */}
                            {this.state.selectedNumbers.length !== 0 && <KenoPayoutBoxes isPotrait={this.state.isPotrait} payouts={this.PAYOUT_TABLE[this.state.selectedNumbers.length] || []} highlightcount={this.state.highlightcount} hoveredIndex={this.state.hoveredPayoutIndex} onHover={this.handleHoverPayout}
                                boxWidth={this.state.isPotrait ? 100 : 120}
                                boxHeight={this.state.isPotrait ? 80 : 80}
                                boxMargin={this.state.isPotrait ? 5 : 10}
                                padding={this.state.isPotrait ? 10 : 20}
                            />}

                        </div>
                        {this.state.selectedNumbers.length === 0 && <div className="fd flex bottom_container">
                            <div className="fd font_30 select1_10">Select 1 - 10 numbers to play</div>

                        </div>}
                    </div>






                    <ControlPanel
                        selected={this.state.selectedNumbers}
                        drawn={this.state.drawnNumbers}
                        onClear={this.clearBet}
                        onDraw={this.drawNumbers}
                        onAutoPick={this.autoPick}
                        isPotrait={this.state.isPotrait}
                        BetAmountHandle={this.BetAmounthandle}
                        DoubleAmounthandler={this.DoubleAmounthandler}
                        HalfAmounthandler={this.HalfAmounthandler}
                        BetAmount={this.state.BetAmount}
                        Gridcover={this.state.Gridcover}
                        balance={this.props.balance}
                        Keno_stake_chipValues={this.props.Keno_stake_chipValues}
                        winpop={this.state.winpop}
                        Keno_stake_minBet={this.props.Keno_stake_minBet}
                        Keno_stake_maxBet={this.props.Keno_stake_maxBet}
                        data={filteredChips}
                        showAlert={this.showAlert.bind(this)}
                    />

                </div>
            </>

        );
    }
}

export default KenoMain;